import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class EditorjsDraftService {
  private KEY = 'editorjs_draft_id';

  constructor(
    private http: HttpClient
  ) {
  }

  getOrCreateDraft(): string {
    let id = localStorage.getItem(this.KEY);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(this.KEY, id);
    }
    return id;
  }

  clearDraft() {
    const id = localStorage.getItem(this.KEY);
    if (id) this.deleteDraft(id).subscribe(() => {})
    localStorage.removeItem(this.KEY);
  }

  saveDraftImage(draft_id: string, file: File) {
    const path = `${environment.apiURL}/editorjs/drafts/${draft_id}`

    const form = new FormData();
    form.append('image', file);

    return this.http.post<{ success:1, file:{ url: string } }>(path, form)
  }

  deleteDraft(draft_id: string) {
    const path = `${environment.apiURL}/editorjs/drafts/${draft_id}`
    return this.http.delete<void>(path)
  }
}
